import {Routes, Route} from  'react-router-dom'
import './App.css';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import Kontakt from './pages/Kontakt';
import Webdesign from './pages/Webdesign';
import Footer from './components/Footer';
import AngebotForm from './pages/AngebotFrom';
import Services from './pages/Services';
import Ueber from './pages/Ueber';
import LassSprechen from './pages/LassSprechen';



function App() {
  return (
    <div className="App">

      <NavBar />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/kontakt" element= {<Kontakt />} />
        <Route path="/webdesign" element={<Webdesign />} />
        <Route path="/angebot-form" element={<AngebotForm />} />
        <Route path="/ueber" element={<Ueber />} />
        <Route path="/lass-sprechen" element={<LassSprechen />} />


      </Routes>
      <Footer />
    </div>
  );
}

export default App;
